module.exports = __webpack_public_path__ + "static/media/info.2115f4fe.svg";